"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _browserSprite = _interopRequireDefault(require("svg-baker-runtime/browser-sprite"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spriteNodeId = '__SVG_SPRITE_NODE__';
var browserSprite = new _browserSprite.default({
  attrs: {
    id: spriteNodeId
  }
});
browserSprite.mount();
var _default = browserSprite;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vkontakte/icons/dist/sprite.js
// module id = 12
// module chunks = 0